<template>
  <div style="padding-top: 10vh;">
    <div v-if="isTopUp || isSchoolTopUp">
      <div v-if="paymentFailed">
        <p>{{ $t('notification.chargeError') }}</p>
        <Button @click="redirectTo">{{ $t('button.back') }}</Button>
      </div>
      <div v-else>
        <p>{{ $t('notification.chargeSuccessful') }}</p>
        <p v-if="redirectTimer > 0">{{ $t('text.redirectTimer') }}</p>
      </div>
    </div>
    <div v-else-if="isMealPlan">
      <div v-if="paymentFailed">
        <p>{{ $t('notification.paymentError') }}</p>
        <Button @click="redirectTo">{{ $t('button.back') }}</Button>
      </div>
      <div v-else>
        <p>{{ $t('notification.paymentSuccessful') }}</p>
        <p v-if="redirectTimer > 0">{{ $t('text.redirectTimer') }}</p>
      </div>
    </div>
    <div v-else>
      <div v-if="paymentFailed">
        <p>{{ $t('notification.paymentError') }}</p>
        <Button @click="redirectTo">{{ $t('button.back') }}</Button>
      </div>
    </div>
  </div>
</template>

<script>
import {PaymentProviders, Workflow} from "@/constants/constants";
import {useAppStore} from "@/stores/app";
import Button from "@/components/barrier-free-template-components/Button.vue";
import {paymentService} from "@/services/api/paymentService";

export default {
  components: {Button},
  data() {
    return {
      paymentFailed: false,
      redirectTimer: window.config.PAYMENT.redirectTimerInSeconds, // Set the initial countdown time (in seconds)
      countdownInterval: null, // This will hold the interval ID
    };
  },
  setup() {
    const appStore = useAppStore();

    return {
      appStore,
    };
  },
  props: {
    payment: {
      Type: String,
    },
    result: {
      Type: String,
    },
    uuid: {
      Type: String,
    },
    sessionId: {
      Type: String,
    },
    sessionResult: {
      Type: String,
    },
    hostedCheckoutId: {
      Type: String,
    },
  },
  computed: {
    isTopUp() {
      return this.appStore.isWorkflow(Workflow.TOP_UP);
    },
    isSchoolTopUp() {
      return this.appStore.isWorkflow(Workflow.SCHOOL);
    },
    isMealPlan() {
      return this.appStore.isWorkflow(Workflow.MEAL_PLAN);
    }
  },
  methods: {
    startRedirectTimer() {
      this.countdownInterval = setInterval(() => {
        if (this.redirectTimer > 0) {
          this.redirectTimer--;
        } else {
          clearInterval(this.countdownInterval);
          this.redirectTo(); // Redirect when timer hits zero
        }
      }, 1000);
    },
    redirectTo() {
      if (this.isTopUp) {
        this.$navigateToCustomerCard(true);
      } else if (this.isSchoolTopUp) {
        this.$navigateToStudentAccounts(true);
      } else if (this.isMealPlan) {
        if (this.paymentFailed) {
          this.$navigateToMealPlanCheckout(true);
        } else {
          this.$navigateToMealPlanner(true);
        }
      } else {
        this.$navigateToOrderConfirmation();
      }
    },
    async processPaymentResult() {
      if (this.payment === PaymentProviders.ADYEN) {
        const result = await paymentService.processPaymentResult(PaymentProviders.ADYEN, {
          uuid: this.uuid,
          sessionId: this.sessionId,
          sessionResult: this.sessionResult
        });
        if (result.exception || result.status !== "completed") {
          return;
        }
        this.result = "S";
      } else if (this.payment === PaymentProviders.PAYONE) {
        const result = await paymentService.processPaymentResult(PaymentProviders.PAYONE, {
          uuid: this.uuid,
          hostedCheckoutId: this.hostedCheckoutId
        });
        if (result.exception || result.status !== "PAYMENT_CREATED") {
          return;
        }
        this.result = "S";
      }
    },
  },
  beforeMount() {
    window.shoppingCart = null;
  },
  async created() {
    if (this.payment === PaymentProviders.ADYEN) {
      await this.processPaymentResult();
    }
    else if (this.payment === PaymentProviders.PAYONE) {
      await this.processPaymentResult();
    }
    if (this.result === 'S') {
      if (this.isTopUp || this.isSchoolTopUp || this.isMealPlan) {
        this.startRedirectTimer(this.result);
      } else {
        this.$navigateToCheckoutFinished();
      }
    } else {
      this.paymentFailed = true;
    }
  },
  beforeDestroy() {
    // Clear the interval when the component is destroyed
    clearInterval(this.countdownInterval);
  },
};
</script>
